<template>
  <svg
    width="16px"
    height="17.8823529px"
    viewBox="0 0 16 17.8823529"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Symbols"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g id="side-menu" transform="translate(-32, -202)" fill="#FFFFFF">
        <g
          id="fitness_center_FILL0_wght400_GRAD0_opsz48"
          transform="translate(32, 202)"
        >
          <polygon
            id="Path"
            points="9.41414141 17.8823529 8.56565657 16.9340463 11.4343434 13.7278669 3.71717172 5.10279263 0.848484848 8.30897207 0 7.36066548 1.13131313 6.05109923 3.58859968e-16 4.78669043 1.71717172 2.86749851 0.868686869 1.91919192 1.71717172 0.970885324 2.58585859 1.89661319 4.28282828 0 5.41414141 1.26440879 6.58585859 0 7.43434343 0.948306595 4.56565657 4.15448604 12.2828283 12.7795603 15.1515152 9.57338087 16 10.5216875 14.8686869 11.8312537 16 13.0956625 14.2626263 15.0374332 15.1111111 15.9857398 14.2626263 16.9340463 13.4141414 15.9857398 11.7171717 17.8823529 10.5858586 16.6179441"
          ></polygon>
        </g>
      </g>
    </g>
  </svg>
</template>
